import { render, staticRenderFns } from "./TicketPage.vue?vue&type=template&id=b836565a&scoped=true&"
import script from "./TicketPage.vue?vue&type=script&lang=js&"
export * from "./TicketPage.vue?vue&type=script&lang=js&"
import style0 from "./TicketPage.vue?vue&type=style&index=0&id=b836565a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b836565a",
  null
  
)

export default component.exports